
import React from 'react';

export default function OutOfRange ({ eventInfo }) {
	return (
		<div className="quote-calculator__out-of-range">
			<h4 className="quote-calculator__out-off-range-heading">{eventInfo.out_of_range_message}</h4>
		</div>
	);
}
